<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-input
          v-model="search"
          @input.native="onOrdersSearch"
          class="input--300"
          type="search"
          placeholder="Search by id"
          name="search"
        />
        <app-select
          @input="onFilterProducts"
          v-model="filter_suppliers"
          :options="supplier_options"
          :reduce="item => item.id"
          placeholder="Supplier"
          class="select--300"
        />
      </app-cells>
      <template v-if="table_bank.items.length">
        <app-cells><h2 class="title">Bank</h2></app-cells>
        <v-client-table
          :data="table_bank.items"
          :columns="table_bank.columns"
          :options="table_bank.options"
          class="table-default"
          :class="{ 'table-default--loading': table_bank_preloader }"
        >
          <template #h__id>
            <div class="table-default__left">ID</div>
          </template>
          <template #h__supplier>
            <div class="table-default__left">Supplier</div>
          </template>
          <template #id="{ row }">
            <div class="table-default__left">
              <router-link :to="{name: 'product-storage-order-detail', params: {id: row.id }}" class="table-default__link-border">
                Order - {{ row.id }}
              </router-link>
            </div>
          </template>
          <template #print="{ row }">
            <div class="table-default__controls">
              <button
                v-if="!print_preload || print_preload !== `print_bank_${row.id}`"
                @click="onPrint(row)"
                type="button"
                :disabled="print_preload"
              >
                <img src="@/assets/img/print-table-icon.svg" alt="Print">
              </button>
              <img v-show="print_preload === `print_bank_${row.id}`" src="@/assets/img/preloader-export.svg" alt="">
            </div>
          </template>
          <template #date="{ row }">
            {{ dateFormat(row.date) }}
          </template>
          <template #supplier="{ row }">
            <router-link
                v-if="is_general_manager || is_product_storage_manager || is_product_storage_supervisor"
                :to="{name: 'supplier-detail', params: {id: row.supplier.id }}"
                class="table-default__link-border"
            >
              {{row.supplier.name }}
            </router-link>
            <div v-else class="table-default__left">{{ row.supplier.name }}</div>
          </template>
          <template #real="{ row }">
            {{row.real.toLocaleString() }} TSh
          </template>
          <template #is_paid="{ row }">
          <span
            class="table-default__colored"
            :class="{ 'table-default__colored--green': row.is_paid, 'table-default__colored--red': !row.is_paid }"
          >
            {{ row.is_paid ? 'Paid' : 'Not paid' }}
          </span>
          </template>
          <template #invoice.file="{ row }">
            <div class="table-default__controls">
              <button
                v-if="row.invoice && row.invoice.file"
                @click="onDownloadInvoice(row)"
                type="button"
              >
                <img src="@/assets/img/download-table-blue-icon.svg" alt="">
              </button>
              <button v-else type="button" disabled><img src="@/assets/img/not-check-red-icon.svg" alt=""></button>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationBank"
              v-if="pagination_bank.pages > 1"
              v-model="pagination_bank.page"
              :page-count="pagination_bank.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_bank.count" :count="table_bank.items.length" :page="pagination_bank.page" />
        </app-cells>
      </template>
      <template v-if="table_cash.items.length">
        <app-cells><h2 class="title">Cash</h2></app-cells>
        <v-client-table
          :data="table_cash.items"
          :columns="table_cash.columns"
          :options="table_cash.options"
          class="table-default"
          :class="{ 'table-default--loading': table_cash_preloader }"
        >
          <template #h__id>
            <div class="table-default__left">ID</div>
          </template>
          <template #h__supplier>
            <div class="table-default__left">Supplier</div>
          </template>
          <template #id="{ row }">
            <div class="table-default__left">
              <router-link :to="{name: 'product-storage-order-detail', params: {id: row.id }}" class="table-default__link-border">
                Order - {{ row.id }}
              </router-link>
            </div>
          </template>
          <template #print="{ row }">
            <div class="table-default__controls">
              <button
                v-if="!print_preload || print_preload !== `print_cash_${row.id}`"
                @click="onPrint(row)"
                type="button"
                :disabled="print_preload"
              >
                <img src="@/assets/img/print-table-icon.svg" alt="Print">
              </button>
              <img v-show="print_preload === `print_cash_${row.id}`" src="@/assets/img/preloader-export.svg" alt="">
            </div>
          </template>
          <template #date="{ row }">
            {{ dateFormat(row.date) }}
          </template>
          <template #supplier="{ row }">
            <router-link
                v-if="is_general_manager || is_product_storage_manager || is_product_storage_supervisor"
                :to="{ name: 'supplier-detail', params: { id: row.supplier.id }}"
                class="table-default__link-border"
            >
              {{ row.supplier.name }}
            </router-link>
            <div v-else class="table-default__left">{{ row.supplier.name }}</div>
          </template>
          <template #cash_request="{ row }">
            <span
              class="status-tag"
              :style="{ 'backgroundColor': row.cash_request.status.code === 'in_process' ? '#439ad1' : row.cash_request.status.code === 'completed' ? '#77b017' : '#5f5f5f' }"
              v-if="row.cash_request"
              v-tooltip="{ content: `Request ID: ${row.cash_request.id}`, placement: 'top-start', offset: 10 }"
            >
              {{ row.cash_request.status.name }}
            </span>
            <span
              v-else
              class="status-tag"
              :style="{ 'backgroundColor': '#f0c427' }"
            >
              Not requested
            </span>
          </template>
          <template #real="{ row }">
            {{row.real.toLocaleString() }} TSh
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationCash"
              v-if="pagination_cash.pages > 1"
              v-model="pagination_cash.page"
              :page-count="pagination_cash.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_cash.count" :count="table_cash.items.length" :page="pagination_cash.page" />
        </app-cells>
      </template>
    </template>
  </div>
</template>

<script>
import { getOrderPrint, getOrdersProduct, getSuppliersProduct } from '@/http'
import debounce from 'lodash/debounce'
import { format, parse } from 'date-fns'
import axios from 'axios'

export default {
  name: 'ProductStorageOrdersCompleted',
  data() {
    return {
      is_loaded: false,
      search: '',
      filter_suppliers: [],
      supplier_options: [],
      table_cash: {
        items: [],
        columns: ['id', 'print', 'date', 'supplier', 'cash_request', 'real'],
        options: {
          headings: {
            'id': 'ID',
            'print': 'Print',
            'date': 'Date',
            'supplier': 'Supplier',
            'cash_request': 'Cash',
            'real': 'Value',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_cash: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_bank: {
        items: [],
        columns: ['id', 'print', 'date', 'supplier', 'real', 'is_paid'],
        options: {
          headings: {
            'id': 'ID',
            'print': 'Print',
            'date': 'Date',
            'supplier': 'Supplier',
            'real': 'Value',
            'is_paid': 'Payment status',
            'invoice.file': 'Invoice',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_bank: {
        pages: 1,
        page: 1,
        count: 1,
      },
      print_preload: null,
      table_cash_preloader: false,
      table_bank_preloader: false,
    }
  },
  computed: {
    show_invoice_col() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_manager' || group.code === 'general_manager')
    },
    is_product_storage_manager() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_manager')
    },
    is_product_storage_supervisor() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_supervisor')
    },
    is_general_manager() {
      return this.$store.state.userGroups.some(group => group.code === 'general_manager')
    }
  },
  created() {
    this.fetchItemsCash()
    this.fetchItemsBank()
    getSuppliersProduct().then(response => { this.supplier_options = response.data })
    if (this.show_invoice_col) this.table_bank.columns.push('invoice.file')
  },
  methods: {
    onFilterProducts() {
      this.search = ''
      this.pagination_bank.page = 1
      this.pagination_cash.page = 1
      this.fetchItemsCash()
      this.fetchItemsBank()
    },
    onPrint(row) {
      this.print_preload = `print_${row.payment_method.code}_${row.id}`
      getOrderPrint(row.id)
        .finally(() => { this.print_preload = null })
        .then(response => { window.open(response.data) })
    },
    onClickPaginationCash(page) {
      this.table_cash_preloader = true
      this.pagination_cash.page = page
      this.fetchItemsCash()
    },
    onClickPaginationBank(page) {
      this.table_bank_preloader = true
      this.pagination_bank.page = page
      this.fetchItemsBank()
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    fetchItemsCash() {
      getOrdersProduct({
        page: this.pagination_cash.page,
        page_size: 20,
        search: this.search,
        status: 'completed',
        payment_method: 'cash',
        supplier: this.search ? '' : this.filter_suppliers
      })
        .then(response => {
          this.table_cash.items = response.data.results
          this.pagination_cash.pages = response.data.pages
          this.pagination_cash.count = response.data.count
          this.table_cash_preloader = false
        })
    },
    fetchItemsBank() {
      getOrdersProduct({
        page: this.pagination_bank.page,
        page_size: 20,
        search: this.search,
        status: 'completed',
        payment_method: 'bank',
        supplier: this.search ? '' : this.filter_suppliers
      })
        .then(response => {
          this.table_bank.items = response.data.results
          this.pagination_bank.pages = response.data.pages
          this.pagination_bank.count = response.data.count
          this.is_loaded = true
          this.table_bank_preloader = false
        })
    },
    onDownloadInvoice(data) {
      axios.get(data.invoice.file, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          const extension = data.invoice.file_name.split('.').pop()
          link.href = url
          link.setAttribute('download', `Invoice ${data.supplier.name} - Order ${data.id}.${extension}`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        })
    },
    onOrdersSearch() {
      this.searchUsers(this)
    },
    searchUsers: debounce(vm => {
      vm.pagination_cash.page = 1
      vm.pagination_bank.page = 1
      vm.fetchItemsCash()
      vm.fetchItemsBank()
    }, 350),
  }
}
</script>
